import { intl } from "LocaleWrapper";
import { Card, FormGroup } from "@cofano/cck";
import { Alert, Box, Grid2 as Grid } from "@mui/material";
import { Language, DataFormat } from "imports/Utils";
import { ShipFromQuery } from "view/ships/ShipDetails";

const ShipContactDetails = ({ ship }: { ship: ShipFromQuery }) => {

	const gridSize =  {
		xs: 4,
	};

	return (
		<Box p={2} pt={ship.contacts.length === 0 ? 2 : 0}>
			{ship.contacts.length === 0 && (
				<Alert severity="info">{Language("NO_CONTACTS_FOUND")}</Alert>
			)}

			{ship.contacts.map((contact, index) => {
				return (
					<Card
						key={contact.id}
						title={Language("CONTACT")}
						subtitle={contact.name || intl.formatMessage({ id: "UNKNOWN" })}
						collapsable={true}
						defaultCollapsed={index !== 0}>
						<Grid spacing={3} container>
							<Grid size={gridSize}>
								<FormGroup label={Language("TYPE")} overflow="hidden">
									{contact.type || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("SHIPS_NAME")} overflow="hidden">
									{contact.name || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("INSERTION")} overflow="hidden">
									{contact.insertion || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("SURNAME")} overflow="hidden">
									{contact.surName || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("EMAIL")} overflow="hidden">
									{contact.email || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("TELEPHONE")} overflow="hidden">
									{contact.telephone || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("FAX")} overflow="hidden">
									{contact.fax || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("ADDRESS_NAME_ONE")} overflow="hidden">
									{contact.address?.name1 || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("ADDRESS_NAME_TWO")} overflow="hidden">
									{contact.address?.name2 || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("ADDRESS")} overflow="hidden">
									{contact.address?.street || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("CLIENT_ZIPCODE")} overflow="hidden">
									{contact.address?.zipCode || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("CLIENT_CITY")} overflow="hidden">
									{contact.address?.town || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("CLIENT_COUNTRY")} overflow="hidden">
									{contact.address?.country || "-"}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("RHINE_LICENSE")} overflow="hidden">
									{DataFormat.boolean(contact.rhineLicense)}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("LARGE_SAILING_LICENSE_A")} overflow="hidden">
									{DataFormat.boolean(contact.grootVaarbewijsA)}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("LARGE_SAILING_LICENSE_B")} overflow="hidden">
									{DataFormat.boolean(contact.grootVaarbewijsB)}
								</FormGroup>
							</Grid>

							<Grid size={gridSize}>
								<FormGroup label={Language("RADAR_LICENSE")} overflow="hidden">
									{DataFormat.boolean(contact.radarLicense)}
								</FormGroup>
							</Grid>
						</Grid>
					</Card>
				);
			})}
		</Box>
	);
};

export default ShipContactDetails;
